import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  message: string | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error.message };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, message: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex h-full w-full flex-col items-center justify-center gap-4 geo-grid p-6 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-orange-500/15 text-orange-400">
            <svg
              className="h-7 w-7"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
              aria-hidden
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m0 3.75h.007M5.91 19.25h12.18a1.5 1.5 0 001.314-2.223l-6.09-10.5a1.5 1.5 0 00-2.628 0l-6.09 10.5a1.5 1.5 0 001.314 2.223z"
              />
            </svg>
          </div>
          <div>
            <h1 className="text-base font-bold text-slate-100">
              Bir şeyler ters gitti
            </h1>
            <p className="mt-1 max-w-xs text-sm text-slate-400">
              Beklenmeyen bir hata oluştu. Sayfayı yenilemek yardımcı olabilir.
            </p>
          </div>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded-lg bg-accent-500 px-4 py-2 text-sm font-semibold text-navy-950 transition-colors hover:bg-accent-400"
          >
            Sayfayı Yenile
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
